require('./contentSummary.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');
// @components
const {
    CmInvestmentFundCell,
} = require('../../cmInvestmentFundCell/cmInvestmentFundCell');
import BrokerLegalDocumentationBox from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentationBox';
// @constants
const {
    CM_ACTIVE_CLASS_MONEY_MARKET,
    CM_ACTIVE_CLASS_FIXED_INCOME,
    CM_ACTIVE_CLASS_EQUITY,
    CM_ACTIVE_CLASS_REAL_ASSETS,
} = require('../../../constants/constants');
const { BROKER_PRODUCT_TYPE_FUNDS } = require('constants/index');

class ContentSummary extends React.Component {
    getRowAmount = subAsset => {
        return {
            amount: subAsset.get('subAssetClassFundAmount'),
            currency: subAsset.get('currency'),
        };
    };

    getInvalidFundMessage(isValid, minFundAmount) {
        const {
            showGeneralMinAmountMessage,
            isFetchingPortfolioInfo,
        } = this.props;
        if (
            isValid === false &&
            minFundAmount &&
            showGeneralMinAmountMessage &&
            !isFetchingPortfolioInfo
        )
            return { amount: minFundAmount, currency: 'EUR' };

        return null;
    }

    getRowClass = assetClass => {
        let rowClass;
        switch (assetClass) {
            case CM_ACTIVE_CLASS_MONEY_MARKET:
                rowClass = 'content-summary__row__money-market';
                break;

            case CM_ACTIVE_CLASS_FIXED_INCOME:
                rowClass = 'content-summary__row__fixed-income';
                break;

            case CM_ACTIVE_CLASS_EQUITY:
                rowClass = 'content-summary__row__equity';
                break;

            case CM_ACTIVE_CLASS_REAL_ASSETS:
                rowClass = 'content-summary__row__real-assets';
                break;

            default:
                rowClass = '';
                break;
        }

        return rowClass;
    };

    getContentSummary = assets => {
        let assetClass;
        let activeSubclass;
        let subAssets;

        const { reportCompleted, immFeatureFlag } = this.props;
        const showExantCosts = immFeatureFlag.get(
            'wealth_build_portfolio_show_costs',
        );

        const getSortingValue = (imm, key) => Number(imm.get(key).slice(-3));
        const sortedAssets = assets
            .map(asset =>
                asset.update('subAssetClassInfo', subAssetClassInfo =>
                    subAssetClassInfo.sort(
                        (a, b) =>
                            getSortingValue(a, 'subAssetClassId') -
                            getSortingValue(b, 'subAssetClassId'),
                    ),
                ),
            )
            .sort(
                (a, b) =>
                    getSortingValue(a, 'assetClassId') -
                    getSortingValue(b, 'assetClassId'),
            );

        const content = sortedAssets.map(
            asset => (
                (assetClass = asset.get('assetClassId')),
                asset.get('subAssetClassInfo').map(subClass => {
                    const assetClassDesc = asset.get('assetClassDesc');
                    activeSubclass = subClass.get('subAssetClassDesc');
                    subAssets = subClass.get('subAssetClassIsinInfo');
                    const investmentClassname = classNames(
                        'row content-summary__row',
                        this.getRowClass(assetClass),
                    );
                    return subAssets.map((subAsset, index) => {
                        const isin = subAsset.get('subAssetClassIsin');
                        const productDefinition = subAsset.get(
                            'subAssetClassFundName',
                        );
                        return (
                            <div className={investmentClassname} key={index}>
                                <div className="col-md-4">
                                    <CmInvestmentFundCell
                                        key={index}
                                        subAssetClassFundName={subAsset.get(
                                            'subAssetClassFundName',
                                        )}
                                        assetClassDesc={assetClassDesc}
                                        activeSubclass={activeSubclass}
                                        amount={this.getRowAmount(subAsset)}
                                        typeRow={assetClass}
                                        invalidFundMessage={this.getInvalidFundMessage(
                                            subAsset.get('isValidAmount'),
                                            subAsset.get('fundMinAmount'),
                                        )}
                                    />
                                </div>
                                <div className="col-md-8">
                                    <BrokerLegalDocumentationBox
                                        isin={isin}
                                        productType={BROKER_PRODUCT_TYPE_FUNDS}
                                        reportCompleted={reportCompleted}
                                        productDefinition={productDefinition}
                                        enableTransactionCost={!showExantCosts}
                                        isBuildYourPortfolio={showExantCosts}
                                    />
                                </div>
                            </div>
                        );
                    });
                })
            ),
        );

        return content;
    };

    render() {
        const { assets } = this.props;
        const content = this.getContentSummary(assets);
        return <div className="content-summary">{content}</div>;
    }
}

ContentSummary.propTypes = {
    assets: PropTypes.object.isRequired,
    showGeneralMinAmountMessage: PropTypes.bool,
    isFetchingPortfolioInfo: PropTypes.bool,
    immGlobalVariables: PropTypes.object.isRequired,
    reportCompleted: PropTypes.func.isRequired,
    immFeatureFlag: PropTypes.object.isRequired,
};

module.exports.ContentSummary = connect(state => ({
    immGlobalVariables: state.globalVariables,
    immFeatureFlag: state.flagBasedFeatures,
}))(ContentSummary);
